import type { DrawerProps } from '@hover/blueprint';
import { Drawer } from '@hover/blueprint';
import React from 'react';

const SlideRightCard = ({ children, ...props }: DrawerProps) => (
  <Drawer {...props}>{children}</Drawer>
);

export { SlideRightCard };
